import { render, staticRenderFns } from "./HorizontalTabsNew.vue?vue&type=template&id=6c519a96&scoped=true&"
import script from "./HorizontalTabsNew.vue?vue&type=script&lang=js&"
export * from "./HorizontalTabsNew.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTabsNew.vue?vue&type=style&index=0&id=6c519a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c519a96",
  null
  
)

export default component.exports